export default __webpack_public_path__ + "static/media/p2.7d4fe211.jpg";